import { View, ViewDensity, ViewType } from "@common/types/views/views";
import { JournalEntryListColumn } from "./journalEntryListViewConfig";
import { JournalEntryVersionColumn } from "./journalEntryVersionsViewConfig";

export const defaultJournalEntryListView: View = {
    type: ViewType.HISTORY_MANUAL_JOURNAL_ENTRY,
    columns: [
        { id: JournalEntryListColumn.DATE },
        { id: JournalEntryListColumn.REFERENCE },
        { id: JournalEntryListColumn.SOURCE },
        { id: JournalEntryListColumn.AMOUNT },
        { id: JournalEntryListColumn.ENTITY },
        { id: JournalEntryListColumn.ACTIONS },
    ],
    filters: {},
    options: {
        selection: true,
        density: ViewDensity.MD,
    },
};

export const defaultJournalEntryVersionsView: View = {
    type: ViewType.HISTORY_MANUAL_JOURNAL_ENTRY_VERSIONS,
    columns: [
        { id: JournalEntryVersionColumn.DATE },
        { id: JournalEntryVersionColumn.LINES },
        { id: JournalEntryVersionColumn.REFERENCE },
        { id: JournalEntryVersionColumn.AMOUNT },
        { id: JournalEntryVersionColumn.ENTITY },
        { id: JournalEntryVersionColumn.ACTIONS },
    ],
    filters: {},
    options: {
        selection: true,
        density: ViewDensity.MD,
    },
};
